import React from 'react';
import { useSearchParams } from 'react-router-dom';

// Public return page for native in-app-browser checkout (Stripe/Shippo).
//
// On native, the checkout Cloud Functions point Stripe's success/cancel URLs
// here. This page loads inside the in-app browser sheet that sits over the
// app; the user taps the ✕ (top-left) to dismiss it, which fires
// `browserFinished` in the app so it can re-sync state (the Stripe webhook is
// the source of truth
// for the actual outcome). Web checkouts never land here — they return to the
// normal in-app progress/confirm routes.
const CheckoutComplete = () => {
  const [params] = useSearchParams();
  const cancelled = params.get('status') === 'cancelled';
  // flow=onboarding is set by createStripeConnectAccount's native return URLs so
  // this page shows payout-account copy instead of payment copy. Payments (and
  // any URL without flow) keep the original "Payment received!" wording.
  const onboarding = params.get('flow') === 'onboarding';

  let title;
  let lead;
  if (onboarding) {
    title = cancelled ? 'Payout setup canceled' : 'Payout account set up!';
    lead = cancelled
      ? 'No changes were made. '
      : 'Your payout account is set up and ready to receive funds. ';
  } else {
    title = cancelled ? 'Checkout canceled' : 'Payment received!';
    lead = cancelled
      ? 'No charge was made. '
      : 'Your payment was processed successfully. ';
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      padding: '24px', maxWidth: '480px', margin: '0 auto'
    }}>
      <div style={{
        width: '64px', height: '64px', borderRadius: '50%',
        backgroundColor: cancelled ? '#f3f4f6' : '#d4edda',
        color: cancelled ? '#6b7280' : '#155724',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '34px', marginBottom: '20px'
      }}>{cancelled ? '↩' : '✓'}</div>

      <h1 style={{ fontSize: '24px', margin: '0 0 10px', color: '#1f2937' }}>
        {title}
      </h1>
      <p style={{ fontSize: '16px', color: '#4b5563', margin: '0 0 24px', lineHeight: 1.5 }}>
        {lead}
        Tap the{' '}
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '1.5em',
            height: '1.5em',
            border: '1px solid currentColor',
            borderRadius: '50%',
            fontSize: '0.8em',
            lineHeight: 1,
            verticalAlign: 'middle',
            boxSizing: 'border-box',
          }}
          aria-label="close"
          role="img"
        >
          ✕
        </span>{' '}
        in the top-left corner to close this page and
        return to the PedalxChange app.
      </p>

      <p style={{ fontSize: '13px', color: '#9ca3af', marginTop: '4px', lineHeight: 1.5 }}>
        It’s safe to close this page — your app will update automatically.
      </p>
    </div>
  );
};

export default CheckoutComplete;
